import { AppComponentsContext, AppComponents, useLogger } from "@amzn/xb-hooks";
import { ReactNode } from "react";

const DefaultErrorFallback = () => {
  const { warn } = useLogger();
  warn("Default T2Fallback reached. Please configure the ExperienceBridgeProvider with the appropriate Fallback");
  return <span data-testid="default-error-fallback" />;
};

const DefaultLoading = () => <span data-testid="default-loading" />;

export const AppComponentsProvider = ({
  children,
  components,
}: {
  children: ReactNode;
  components?: AppComponents;
}) => {
  return (
    <AppComponentsContext.Provider
      value={{
        Tier2LiveComponentErrorFallback: components?.Tier2LiveComponentErrorFallback ?? DefaultErrorFallback,
        LoadingIndicator: components?.LoadingIndicator ?? DefaultLoading,
      }}
    >
      {children}
    </AppComponentsContext.Provider>
  );
};
